import {type ActionTree} from 'vuex';

const actions: ActionTree<ModuleSchoolState, RootState> = {
    toggle({commit}, entity)
    {
        commit('toggle', {entity: parseInt(entity)});
    },
    setSearch({commit}, search)
    {
        commit('setSearch', {search});
    }
};

export default actions;